/* Sisters Moto: compact collection header behaviour (snippets/sm-collection-header.liquid)
   1. Description: shows "Read more" only when the text is longer than 2 lines.
   2. Category chips: scrolls the current chip into view inside its own row
      (never scrolls the page). */
(function () {
  'use strict';

  function initDesc(desc) {
    if (desc.dataset.smInit) return;
    desc.dataset.smInit = '1';
    var btn = desc.parentNode.querySelector('[data-sm-coll-more]');
    if (!btn) return;
    if (desc.scrollHeight <= desc.clientHeight + 4) {
      // short enough: show it all, no button
      desc.classList.remove('is-clamped');
      return;
    }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var clamped = desc.classList.toggle('is-clamped');
      btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      btn.textContent = clamped ? 'Read more' : 'Show less';
    });
  }

  function initChips(list) {
    if (list.dataset.smInit) return;
    list.dataset.smInit = '1';
    var current = list.querySelector('[aria-current="page"]');
    if (!current || list.scrollWidth <= list.clientWidth) return;
    var li = current.parentNode;
    var left = li.offsetLeft - 16;
    if (left > 0) list.scrollLeft = left;
  }

  function init() {
    document.querySelectorAll('[data-sm-coll-desc]').forEach(initDesc);
    document.querySelectorAll('[data-sm-coll-chips]').forEach(initChips);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
